import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { MyGame, config } from '../game';
var StarfallPage = function () {
    var gameRef = useRef(null);
    useEffect(function () {
        gameRef.current = new MyGame(config);
        return function () {
            var _a;
            (_a = gameRef.current) === null || _a === void 0 ? void 0 : _a.destroy(true);
            gameRef.current = null;
        };
    }, []);
    return (React.createElement("div", { style: { padding: '20px' } },
        React.createElement(Link, { to: "/", style: { textDecoration: 'none', color: '#2196F3' } }, "\u2190 Back to Home"),
        React.createElement("h1", null, "Starfall"),
        React.createElement("div", { id: "game" })));
};
export default StarfallPage;
